import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './FunctionButton.module.scss';

const cx = classNames.bind(styles);

const FunctionButton = ({
  text = '',
  type = 'medium',
  accent = false,
  center = false,
  pressed = false,
  className = '',
  children = null,
  ...rest
}) => {
  return (
    <button type="button" className={cx(['container', type, { accent, center, pressed }, className])} {...rest}>
      {children || text}
    </button>
  );
};

FunctionButton.propTypes = {
  text: PropTypes.string,
  type: PropTypes.oneOf(['small', 'medium', 'large']),
  accent: PropTypes.bool,
  center: PropTypes.bool,
  pressed: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default React.memo(FunctionButton);
